import { Component, OnInit, OnDestroy } from '@angular/core';
import { filterPageTypes, FilterGroup, filterActions } from 'src/app/store/filters.era';
import { ShareOSSDotMenuChoices, allDefaultShareColumns, shareTableColumnsById, tableLightColors } from 'src/app/helpers/table-helpers';
import { ShareOSSInfo, LabelMaps, makeEmptyLabelMaps } from 'src/app/store/events.era';
import { JoiEvent } from './../../store/events.era';
import { ConfirmDeleteData, openConfirmDeleteGetResult } from 'src/app/components/dialog.confirmDelete.component';
import { accountEventStates } from 'src/app/store/reselectors/null.reselector';
import { SimpleConfirmationDialogComponent, ConfirmationDialogData } from 'src/app/components/dialogues-general/simple-confirmation.dialog.component';
import { shareOSSReselector, shareInfoReselector } from 'src/app/store/reselectors/onsite.share.reselector';
import { NestedCheckGroup, NestedChecksDialogData, NestedChecksDialogComponent, NestedChecksReturnData } from 'src/app/components/wizards/nested-checks.dialog.component';
import { FilterDialogComponentParams } from 'src/app/components/filters/filters-ui.models';
import { FiltersDialogComponent } from 'src/app/components/filters/filters-dialog.component';
import { AllSameKeysToTypeEnforcer, generateEmailLink } from '../../helpers/helpers';
import { sharedOnsiteTimelineReselector } from 'src/app/store/reselectors/onsite.reselector';
import { Performer } from 'src/app/store/performers.era';
import { OnsiteSingleTimeline } from 'globals/store/onsite.data';
import { traceNames } from 'src/app/services/performance.tracking.data';
import { TableColumn, TableMenuItem, TableDotMenuItem } from 'src/app/helpers/table.data';
import { ShareTableData } from 'src/app/helpers/table-column-types';
import { Sponsor } from 'globals/store/sponsors.data';
import { Ranking } from 'globals/store/events.data';
import { PAGE_NAME } from 'src/app/services/event.permissions.service';
import { Wrapper } from 'src/app/components/wrapper.component';
import { Subject } from 'rxjs';
import { sleepForMS } from 'src/app/helpers/helpers';
import { programSessionsActivitesMegaTagReselector } from '../../store/reselectors/programs.reselector';
import { TagPanelData } from 'globals/store/tags.data';
import { BrandingData, BrandingSelectData } from 'globals/store/publish.data';
import { brandDataReselector } from '../../store/reselectors/publish.reselector';
import { PROGRAM_NAMES } from 'globals/store/programs.data';
import { Dictionary } from '@ngrx/entity';
import { compactDate, str2Date } from 'globals/helpers/helpers';
import { CommonModule } from '@angular/common';
import { LoaderComponent } from 'src/app/components/loader/loader.component';
import { TopMenuComponent } from '../program/top.menu';
import { MobileMenuComponent } from 'src/app/components/menu/mobile-menu.component';
import { JoiMessageComponent } from 'src/app/components/cards/joi-message.component';
import { LoaderPaneFragmentComponent } from 'src/app/components/loader/loader-pane-fragment.component';
import { NestedTableComponent } from 'src/app/components/nested-table/nested-table.component';
import { AbnormalStateComponent } from '../dashboard/abnormal_state.component';
import { CommandMenuComponent } from 'src/app/components/nav-bar/command-menu.component';
import { BlackBarWrapperComponent } from 'src/app/components/wrappers/black-bar-wrapper.component';
import { ShareCodeComponent } from '../share/share-code.component';
import { IconTextComponent } from 'src/app/components/buttons/icon-text.component';
import { SharedTimelineComponent } from 'src/app/components/wrappers/shared-timeline-wrapper.component';
import { OnsiteShareTimelineComponent } from './onsite.share.timeline.component';
import { TrafficLightComponent } from 'src/app/components/misc/traffic-light.component';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'onsite-share',
    templateUrl: './onsite.share.html',
    styleUrls: ['./onsite.share.scss', '../../page.scss'],
    standalone: true,
    imports: [CommonModule, MatButtonModule, LoaderComponent, TopMenuComponent, MobileMenuComponent, JoiMessageComponent, LoaderPaneFragmentComponent, NestedTableComponent, AbnormalStateComponent, CommandMenuComponent, BlackBarWrapperComponent, ShareCodeComponent, IconTextComponent, OnsiteShareTimelineComponent, TrafficLightComponent],
})
export class OnsiteShareComponent extends Wrapper<OnsiteShareComponent> implements OnInit, OnDestroy {

  readonly _file: string = "onsite.share.component.ts";
  private $selectTimeline: Subject<boolean> = new Subject()
  filterPage = filterPageTypes.onsiteShare
  page_name = PAGE_NAME.oss_share
  nullState = accountEventStates.notShared
  nullTitle = 'Share a schedule timeline'
  selectedShareInfo: ShareOSSInfo
  shareId: string
  processing = false
  message = ''
  oneWillUpdateMessage = "1 timeline will be updated immediately."
  oneUpdatedMessage = "1 timeline was updated successfully"
  SHARED_MESSAGE = 'Below is what your audience will see when they visit the shareable webpage.'
  UNSHARED_MESSAGE = 'Below is a preview of the shareable webpage.'
  madeWithJoi = true
  traceNames = traceNames


  canUpdateCount = 0
  MESSAGE_DISPLAY_MS = 5000
  selectedRowIds: Set<string> = new Set()
  showActivityStatus = false

  performerRoles: Dictionary<Ranking>
  event: JoiEvent
  columnData: TableColumn[] = allDefaultShareColumns
  columnsById: { [id: string]: TableColumn } = shareTableColumnsById
  singleSelectionMenuItems: TableMenuItem[] = [
    { title: 'Edit', method: this.editShareView.bind(this) },
    { title: 'Duplicate', method: this.duplicateShareView.bind(this) },
  ]
  multiSelectionMenuItems: TableMenuItem[] = [
    { title: 'Delete', method: this.deleteShareView.bind(this) }
  ]
  menuItems: TableMenuItem[] = []
  dotMenuItems: AllSameKeysToTypeEnforcer<ShareOSSDotMenuChoices, TableDotMenuItem> = {
    view: { id: 'view', title: 'View', method: this.openShareView.bind(this) },
    edit: { id: 'edit', title: 'Edit', method: this.editSingleShareView.bind(this) },
    delete: { id: 'delete', title: 'Delete', method: this.deleteSingleShareView.bind(this) },
    duplicate: { id: 'duplicate', title: 'Duplicate', method: this.duplicateSingleShareView.bind(this) },
  }
  defaultColumnId = 'name'
  shareList: ShareTableData[] = []
  shareTableRowsById: { [id:string]: ShareTableData } = {}

  labelMaps: LabelMaps = makeEmptyLabelMaps()
  timeline: OnsiteSingleTimeline[]
  performers: { [pId: string]: Performer }
  sponsors: { [pId: string]: Sponsor }
  sponsorTypes: { [tId:string]: Ranking }
  ossShareInfo: ShareOSSInfo
  searchTerm = ''
  tagMap: { [vId:string]: TagPanelData } = {}
  brandingData: BrandingData

  ngOnDestroy() {
    this.$selectTimeline.next(true); this.$selectTimeline.complete();
  }

  ngOnInit() { 
    const brandingSelectData: BrandingSelectData = {
      type: 'forms',
      brandFormType: 'schedules'
    }
    this.selectProp(brandDataReselector, brandingSelectData, 'brandingData')

    this.subProp(this.store.select(programSessionsActivitesMegaTagReselector), 'tagMap')
    this.uiService.changePageTitle("Onsite Share", true);
    this.subProp(this.store.select('filters', 'onsiteShare', 'search'), 'searchTerm')
    this.subCallback(this.store.select('events', 'event'), event => {
      this.event = event
    })
    this.subProp(this.store.select('events', 'labelMaps'), 'labelMaps')
    this.subCallback(this.store.select(shareOSSReselector), ({ shareTableData, shareTableRowsById }) => {
      // console.log({ shareTableData })
      this.shareList = shareTableData
      this.shareTableRowsById = shareTableRowsById
    })

  }
  
  selectIds(ids: Set<string>) {
    setTimeout(() => {
      this.menuItems = ids.size === 1 ? [...this.singleSelectionMenuItems, ...this.multiSelectionMenuItems] : [...this.multiSelectionMenuItems]
    }, 0)
  }

  openShareView(shareItem: ShareTableData) {
    this.shareId = shareItem.shareInfo.id
    this.selectCallback(sharedOnsiteTimelineReselector, this.shareId, (data: any) => {
      // console.log("Onsite Share Data", data)
      if (!data) return
      const { timeline, performers, info, sponsors, sponsorTypes, showActivityStatus, tagMap, performerRoles } = data
      this.performers = performers
      this.sponsors = sponsors
      this.sponsorTypes = sponsorTypes
      this.timeline = timeline
      this.ossShareInfo = info
      this.showActivityStatus = showActivityStatus 
      this.tagMap = tagMap
      this.performerRoles = performerRoles
    }, this.$selectTimeline)

    this.selectCallback(shareInfoReselector, this.shareId, (shareInfo: any) => {
      this.selectedShareInfo = shareInfo
      
      if (!shareInfo) return
      
      this.madeWithJoi = !shareInfo.excludedFieldIds || !shareInfo.excludedFieldIds.includes('madeWithJoi')
      this.loadSingleShareViewFilters(shareInfo.filters)

    }, this.$selectTimeline)
  }

  async loadSingleShareViewFilters(filters: FilterGroup): Promise<void> {
    if (!filters) {
      this.store.dispatch(filterActions.clearFilterGroup(filterPageTypes.onsiteShare))
      return
    }

    this.filtersService.filterOnsiteShareFilters(filters)
    await sleepForMS(300) // nested table clears filters second without this
    this.store.dispatch(filterActions.updateFilters({ filterGroup: filterPageTypes.onsiteShare, filters }))
  }

  closeShareView() {
    this.shareId = null;
    this.selectedShareInfo = null;
    this.$selectTimeline.next(true)
  }

  editSingleShareView({ shareInfo }: ShareTableData) {
    this.openGreenInputDialog('Timeline Name and Description', 'Update your timeline name and description', 'Timeline name', 'UPDATE', shareInfo.title, false, shareInfo.description, 'Timeline description').then(result => result && this.shareOnsiteService.changeShareOSSViewNameAndDescription(shareInfo, result.values[0], result.values[1]))
  }

  editShareView(shareTableData: ShareTableData[]) {
    this.editSingleShareView(shareTableData[0])
  }

  setMessage(message: string) {
    this.message = message
    setTimeout(() => this.message = '', this.MESSAGE_DISPLAY_MS)
  }

  duplicateSingleShareView({ shareInfo }: ShareTableData) {
    this.openGreenInputDialog('Duplicate Timeline', `Duplicate ${shareInfo.title} to a new timeline`, 'Timeline name', 'DUPLICATE', `${shareInfo.title} copy`).then(result => result && this.shareOnsiteService.duplicateShareOSSView(this.eventService.eventId, shareInfo, result.values[0]))
  }

  duplicateShareView(shareTableData: ShareTableData[]) {
    this.duplicateSingleShareView(shareTableData[0])
  }

  deleteSingleShareView(shareTableItem: ShareTableData, event) {
    this.deleteShareView([shareTableItem], event)
  }

  async deleteShareView(shareTableData: ShareTableData[], event) {
    const n = shareTableData.length
    const data: ConfirmDeleteData = {
      title: `Delete Timeline${n === 1 ? '' : 's'}`,
      para: `Are you sure you want to delete ${n === 1 ? 'this' : 'these ' + n} timeline${ n === 1 ? '' : 's'}?  This action cannot be undone`,
      rect: event.target.getBoundingClientRect(),
      deleteButtonText: 'DELETE',
      dialog: this.dialog
    }
    
    const del = await openConfirmDeleteGetResult(data)
    if (!del) return

    this.shareOnsiteService.deleteShareOSSViews(shareTableData.map(data => data.shareInfo))

  }

  openGreenInputDialog(title: string, header: string, placeholder: string, successLabel: string, currentValue: string = null, emptyOK = false, secondValue: string = null, secondPlaceholder: string = null) {
    return this.openInputDialog(this.uiService.labelsByType.event.color, title, header, placeholder, successLabel, currentValue, emptyOK, secondValue, secondPlaceholder)
  }

  addTimeline() {
    this.openGreenInputDialog('Add a Timeline', 'Give your new timeline a name and description', 'Timeline name', 'ADD', null, false, '', 'Timeline description').then(result => result && this.shareOnsiteService.addNewShareOSSView(result.values[0], result.values[1]))
  }

  emailGenerator(publishCode: string) {
    const firstDate = this.event.first_date
    const dateText = firstDate ? `, ${compactDate(str2Date(firstDate))}` : ''
    const title = this.event.title || 'untitled event'
    const subject = `Information for ${title}${dateText}`
    const body = `Hi there,\n\nPlease click on the link below to view your schedule for ${title}${dateText}.\n\n${publishCode}\n\nThanks`
    return generateEmailLink(subject, body)
  }

  async share() {

    const data: ConfirmationDialogData = {
      confirmText: 'SHARE NOW',
      title: 'Share On Site Schedule',
      description: `${ this.selectedShareInfo.status === 'unshared' ? 'The webpage will become active again' : 'A webpage will be generated'} so you can share the schedule. Changes to the On Site Schedule and Program are updated automatically.`
    }

    const confirmed = await this.openDialogGetResult(SimpleConfirmationDialogComponent, { width: '480px', disableClose: true, data })
    if (!confirmed) return

    this.processing = true
    try {
      await this.shareOnsiteService.shareOSSTimeline(this.selectedShareInfo.id)
    } finally {
      this.processing = false
    }
    
  }

  async unshare() {

    const data: ConfirmationDialogData = {
      confirmText: 'UNSHARE NOW',
      title: 'Unshare On Site Schedule',
      description: 'Your timeline will be unpublished immediately. Visitors to your shared webpage will not be able to see your timeline.\n\nYou can reshare to the same webpage at any time.',
      warning: true,
    }
    const confirmed = await this.openDialogGetResult(SimpleConfirmationDialogComponent, { width: '480px', disableClose: true, data })
    if (!confirmed) return
    
    this.processing = true
    const successful = await this.shareOnsiteService.unshareOSSTimeline(this.selectedShareInfo.id)
    this.processing = false

  }

  editFields() {
    const data: NestedChecksDialogData = {
      title: 'Display options',
      successLabel: 'SAVE',
      instructions: 'Choose which fields appear in your timeline.',
      deselectedIds: this.selectedShareInfo.excludedFieldIds || [],
      backgroundColor: this.uiService.labelsByType.event.color,
      nestedCheckGroups: nestedFieldCheckGroups
    }
    this.openDialogGetResult<NestedChecksReturnData>(NestedChecksDialogComponent, { width: '480px', disableClose: true, data }).then(result => {
      if (!result) return
      this.shareOnsiteService.changeExcludedOSSShareInfoFields(this.selectedShareInfo, result.deselectedIds)
    })
  }

  openFilters() {
    this.filtersService.buildFullOnsiteTimelineFilterUI(filterPageTypes.onsiteShare).then(filterGroupings => {
      const params: FilterDialogComponentParams = {width: '770px', autoFocus: false, data: { filterPage: filterPageTypes.onsiteShare, filterGroupings }}
      this.openDialogGetResult(FiltersDialogComponent, params).then(changedFilters => {
        if (changedFilters) {
          this.shareOnsiteService.changeOSSShareFilters(this.selectedShareInfo)
        }
      })
    })
  }

}


const nestedFieldCheckGroups: NestedCheckGroup[] = [{
  groupName: 'Event',
  checkboxes: [{
    label: 'Event name',
    id: 'eventName'
  },{
    label: 'Timeline name',
    id: 'publishedName',
  },{
    label: 'Timeline description',
    id: 'publishedDescription',
  },{
    label: 'Dates',
    id: 'eventDate'
  },{
    label: 'Made with Joi logo',
    id: 'madeWithJoi'
  }]
},{
  groupName: 'Activities',
  checkboxes: [{
    label: 'Activity completion status',
    id: 'activityStatus',
  },{
    label: 'Activity description',
    id: 'activityDescription',
  },{
    label: 'Activity labels',
    id: 'activityLabels'
  },{
    label: PROGRAM_NAMES.btn + ' detail (in activities)',
    id: 'aPrograms',
    children: [{
      label: PROGRAM_NAMES.btn + ' nickname',
      id: 'aProgramName'
    },{
      label: 'Venue room/location',
      id: 'aLocation'
    },{
      label: 'Venue name',
      id: 'aVenue'
    },{
      label: 'Venue Address',
      id: 'aAddress'
    },]
  },]
},{
  groupName: 'Session',
  checkboxes: [{
    label: 'Session description',
    id: 'sessionDescription'
  },{
    label: 'Session labels',
    id: 'sessionLabels'
  },{
    label: 'Public links',
    id: 'publicLinks'
  },{
    label: PROGRAM_NAMES.btn + ' detail (in sessions)',
    id: 'sPrograms',
    children: [{
      label: PROGRAM_NAMES.btn + ' nickname',
      id: 'sProgramName'
    },{
      label: 'Venue room/location',
      id: 'sLocation'
    },{
      label: 'Venue name',
      id: 'sVenue'
    },{
      label: 'Venue Address',
      id: 'sAddress'
    },]
  }]
},{
  groupName: 'Performers',
  checkboxes: [{
    label: 'Performers',
    id: 'performers',
    children: [{
      label: 'Photo',
      id: 'photoUrl',
    },{
      label: 'Line 1',
      id: 'line1',
    },{
      label: 'Line 2',
      id: 'line2',
    },{
      label: 'Performer roles',
      id: 'performerRoles',
    },{
      label: 'Social links',
      id: 'social',
    }, {
      label: 'Performer labels',
      id: 'performerLabels',
    } ,{
      label: 'Bio',
      id: 'bio',
    },{
      label: 'Logo',
      id: 'logoUrl',
    },]
  }]
}, {
  groupName: 'Sponsors',
  checkboxes: [{
    label: 'Sponsors',
    id: 'sponsors',
    children: [{
      label: 'Logo',
      id: 'sponsorProfileLogoUrl',
    },{
      label: 'Sponsor type',
      id: 'sponsorProfileType',
    }, {
      label: 'Sponsor labels',
      id: 'sponsorLabels',
    } ,{
      label: 'Social links',
      id: 'sponsorProfileSocial',
    },{
      label: 'Description',
      id: 'sponsorProfileDescription',
    },{
      label: 'Call to action',
      id: 'sponsorProfilecallToAction',
    },]
  }]
}, {
  groupName: 'Setups',
  checkboxes: [{
    label: 'Setups',
    id: 'setups',
    children: [{
      label: 'Access time',
      id: 'access',
    },{
      label: 'Cleared time',
      id: 'clear',
    }]
  }]
}]
